module.exports = __webpack_public_path__ + "img/unggah_data.e7237fd8.svg";